import { Link } from 'react-router-dom';

const footerLinks = {
  product: {
    title: '产品',
    links: [
      { label: '旗舰系列', path: '/category/flagship' },
      { label: '标准系列', path: '/category/standard' },
      { label: '青春系列', path: '/category/lite' },
      { label: '特别限定', path: '/category/special' },
      { label: '智能配件', path: '/category/accessories' },
    ],
  },
  support: {
    title: '支持',
    links: [
      { label: '使用指南', path: '/article/baoyu-ecosystem-guide' },
      { label: '安全白皮书', path: '/article/baoyu-security-whitepaper' },
      { label: '常见问题', path: '/about#faq' },
      { label: '联系我们', path: '/about#contact' },
    ],
  },
  about: {
    title: '关于',
    links: [
      { label: '品牌故事', path: '/about' },
      { label: '用户口碑', path: '/about#reviews' },
      { label: '新闻动态', path: '/category/all' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="py-14 grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="text-xl font-bold tracking-tight text-background-50 whitespace-nowrap">
              baoyu
            </Link>
            <p className="mt-3 text-sm text-background-50/70 leading-relaxed">
              以创新科技和卓越品质，<br />
              为每一位用户创造非凡体验。
            </p>
          </div>

          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                {section.title}
              </h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-50/60 transition-colors duration-200 whitespace-nowrap hover:text-background-50"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-50/10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/50">
            &copy; {new Date().getFullYear()} baoyu. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-50/50 text-xs transition-colors duration-200 hover:text-background-50" rel="nofollow">隐私政策</a>
            <a href="#" className="text-background-50/50 text-xs transition-colors duration-200 hover:text-background-50" rel="nofollow">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}